import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id 9C36DCFC-FBBE-4AE2-8E27-952D10E296E3
 * name egg-outline
 * version: 5.1.45
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/egg-outline.svg
 * tags
 * - Food / Drink 
 * - Agriculture 
 */
export const EggOutlineIcon = createSvgIcon(<><path d="M12 4C14.32 4 17.5 10.7 17.5 14.5C17.5 17.53 15.03 20 12 20S6.5 17.53 6.5 14.5C6.5 10.7 9.68 4 12 4M12 2C7.86 2 4.5 10.36 4.5 14.5C4.5 18.64 7.86 22 12 22S19.5 18.64 19.5 14.5C19.5 10.36 16.14 2 12 2Z" /></>, 'EggOutlineIcon');
export default EggOutlineIcon